<template>
    <div class="container">
        <CommonBreadcrumb class="bread_block" /> 
         <!-- {{metaObj}} -->
        <div class="main_title">
            <h1 class="mb-0 font-active">We're Here For You!</h1>
            <p class="mb-0" v-if="$country.is_india">Our team of dedicated experts is available on chat, email and phone to guide you with your diamond and {{ $t('jewelry') }} buying requirements and resolve all your queries.</p>
            <p class="mb-0" v-else>Our team of dedicated experts is available on chat, email, and phone to guide you with your diamond and {{ $t('jewelry') }} buying <br> requirements and resolve all your queries.</p>
        </div>
        
        <div class="row contact_block">
            <div class="col-md-6">
                <div class="row contact_type_block">
                    <div class="col-lg-8 col-md-11">
                        <div class="contact_box">
                            <h3 class="mb-4 font-active" >Call Us</h3>
                            <p>Call Us on <a rel="nofollow" :href="'tel:'+$country.mobile">{{ $country.mobile }}</a> between Monday to Friday from 10 AM to 6 PM.</p>
                            <!-- <a rel="nofollow" :href="'tel:'+$country.mobile">call us</a> -->
                        </div>
                        <div class="contact_box radious_eight">
                            <h3 class="mb-4 font-active" >Chat </h3>
                            <p>Chat with us between Monday to Friday from 10 AM to 6 PM.</p>
                            <CommonBasePrimary @emit-event="openTawkChat">live chat</CommonBasePrimary>
                        </div>
                        <div class="contact_box">
                            <h3 class="mb-4 font-active" >Appointment </h3>
                            <p v-if="$country.is_india">
                                Shop from the comfort of your home under the guidance of a gemologist and {{ $t('jewelry') }} specialist at absolutely no cost or inspect and compare a wide range of diamonds in person with our experts at our office in Mumbai.
                                <br><br>
                                <strong>Our Office Address:</strong> <br> Ground Floor, 1-8 Salasar Estate, <br> Yadav Nagar, Dahisar East
                                Mumbai, <br> Maharashtra - 400068 (India)
                            </p>
                            <p v-else>Shop from the comfort of your home under the guidance of a gemologist and {{ $t('jewelry') }} specialist at absolutely no cost. Or Inspect and compare a wide range of diamonds in person with our experts at our office in New York.  <br><br>
                            Our office address : Friendly Diamonds Inc, 20 W 47th St Suite #716, New York, NY 10036, United States </p>
                            <NuxtLink class="read_more radious_four" :to="localePath('/appointment')">Book appointment </NuxtLink>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="contact_box mb-0">
                    <h2 class="mb-4 font-active">Send Us A Message</h2>
                    <p>Email us at <a :href="`mailto:${$country.email}`">{{ $country.email }}</a>, and our customer care team will revert back to you within 24 business hours. </p>
                </div>
                <form ref="contact_form" @submit.prevent="submitForm">
                    <div class="row">
                        <div class="col-md-12 col-12 pb-4 column select_block_mod">
                            <!-- <BaseInput name="name" :required="true" :id="''" :mode="{invalid: errorMessages.name}" placeholder="Your Name *" type="text" v-model="formData.name" /> -->
                            <label for="">Your Name *</label>
                            <input type="name" name="name" required="true" :class="{invalid: errorMessages.name}" v-model="formData.name">
                            <span v-if="errorMessages.name" class="error-msg">{{ errorMessages.name.join(" ") }}</span>
                        </div>
                        <div class="col-md-6 col-12 pb-4 column select_block_mod">
                            <!-- <BaseInput name="email" :required="true" :id="''" :mode="{invalid: errorMessages.email}" placeholder="Your Email Address *" type="email" v-model="formData.email" /> -->
                            <label for="">Your Email Address *</label>
                            <input type="email" name="email" required="true" :class="{invalid: errorMessages.email}" v-model="formData.email">
                            <span v-if="errorMessages.email" class="error-msg">{{ errorMessages.email.join(" ") }}</span>
                        </div>
                        <div class="col-md-6 col-12 pb-4 column select_block_mod">
                            <!-- <BaseInput name="phone" :required="false" :id="''" :mode="{invalid: errorMessages.phone}" placeholder="Your Phone (optional)" type="number" v-model="formData.phone" /> -->
                            <label for="">Your Phone (Optional)</label>
                            <input type="string" name="phone"  :class="{invalid: errorMessages.phone}" v-model="formData.phone">
                            <span v-if="errorMessages.phone" class="error-msg">{{ errorMessages.phone.join(" ") }}</span>
                        </div>
                        <div class="col-md-12 pb-4 column">
                            <div class="textarea_box">
                                <label>Your Message</label>
                                <textarea name="message" rows="5" maxlength="250" :class="{'invalid': errorMessages.message}" placeholder="" v-model="formData.message" />
                                <span v-if="errorMessages.message" class="error-msg">{{ errorMessages.message.join(" ") }}</span>
                                <p class="mb-0"> {{formData.message.length}}/250 characters</p>
                            </div>
                        </div>
                        <div v-if="!showSuccess" class="col-md-12 pb-4">
                            <CommonBasePrimary v-if="showLoader">please wait...</CommonBasePrimary>
                            <CommonBasePrimary v-else type="submit">send</CommonBasePrimary>
                        </div>
                        <div v-if="showSuccess" class="col-md-12 pb-4">
                            <div class="alert alert-info mb-0" role="alert">Request successfully submitted </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <FaqDynamicFaq />
    </div>
</template>

<script setup>
    // import { useFetchMeta } from '@/composables/useFetchMeta';
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
    const localePath = useLocalePath();
    const { $country } = useNuxtApp();



    // Define reactive variables
    const formData = reactive({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const errorMessages = ref({});
    const showLoader = ref(false);
    const showSuccess = ref(false);

    // Method to clear form data
    const emptyData = () => {
        formData.name = '';
        formData.email = '';
        formData.phone = '';
        formData.message = ''
    };

    // Method to submit form data
    const submitForm = async () => {
        errorMessages.value = {};
        showLoader.value = true;

        try {
            const response = await $fetch(useCountryPath('/contact/store'), {
                method: 'POST',
                body: formData
            });

            if (response.success) {
                showSuccess.value = true;
                showLoader.value = false
                emptyData(); // Clear form data
                setTimeout(() => {
                    showSuccess.value = false;
                    showLoader.value = false
                },2000);

            } 
        } catch (errors) {
            showLoader.value = false
            errorMessages.value = errors.data.errors;
        } 
    };

    // Method to handle Tawk.to chat
    const openTawkChat = () => {
        try {
            if (import.meta.client && window.Tawk_API) {
            window.Tawk_API.toggle();
            console.log('clicked');
        }
        } catch (error) {
            console.log(error);
        }
    };

        
</script>

<style scoped>
.select_block_mod label {
    font-size: 14px;
    font-weight: 600;
    display: block;
    color: #363030;
}
label {
   margin-bottom: 0.5rem;
}
.select_block_mod input.invalid {
    border: 1px solid red;
}
.select_block_mod input {
  
    font-size: 16px;
    height: 45px;
    font-weight: 500;
    width: 100%;
    padding: 0 10px;
    outline: none;
}
 .read_more {
    background: var(--green);
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    border-radius: 8px;
}
.main_title {
    margin-bottom: 4%;
}
.main_title h1 {
    font-size: 40px;
    text-align: center;
    
    padding-bottom: 2%;
}
.main_title p {
    text-align: center;
    color: #6a6161;
    font-size: 16px;
}
h3, h2 {
    font-size: 30px; 
}

.contact_box p {
    color: #6a6161;
    font-size: 16px;
}
.contact_box p a {
    color: #508a7b;
}
.contact_box {
    margin-bottom: 10%;
}
.alert-info {
    color: #0c5460;
    background-color: #d1ecf1;
    border-color: #bee5eb;
}

@media(max-width: 992px){
 
    .main_title h1 {
        font-size: 32px;
    }
    .main_title p br {
        display: none;
    }
    h3, h2{
        font-size: 24px;
    }
}
@media(max-width: 767px){
    .main_title h1{
        font-size: 32px;
    }
    .main_title p{
        font-size: 16px;
    }
   
    .contact_block{
        flex-direction: column-reverse;
    }
    h3, h2{
        text-align: left;
        margin-bottom: 10px !important;
    }
    .contact_type_block {
        margin-top: 10%;
    }
}
</style>
